import { Component, HostListener, signal } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { BollettaComponent } from 'src/app/bolletta/bolletta.component';
import { ProductsRelatedComponent } from 'src/app/products-related/products-related.component';
import { MatCardModule } from '@angular/material/card';
import { EventData, EventInteractionService } from '@mare-common/ngx-mare-common';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { fadeInUpAnimation } from 'src/app/shared/animations/animations';
import { LandingService } from 'src/app/services/landing.service';

@Component({
  selector: 'app-section-bolletta',
  standalone: true,
  imports: [CommonModule,
    BollettaComponent,
    ProductsRelatedComponent,
    MatCardModule,
    NgOptimizedImage,
    TranslateModule,
    SharedModule,
    MatButtonModule
  ],
  animations: [
    fadeInUpAnimation
  ],
  templateUrl: './section-bolletta.component.html',
  styleUrls: ['./section-bolletta.component.scss']
})
export class SectionBollettaComponent {
  showContent$ = signal<boolean>(false);

  showBenhmarkPromo$ = signal<boolean>(true);
  inViewport = false;
  visibilityState: { [key: string]: string } = {
    bolletta:'inactive',
    promo: 'inactive',
    related: 'inactive'
  };
  seen: boolean = false;
  constructor(private eventInteractionService: EventInteractionService,
    private router: Router,
    private landingService: LandingService
  ) {
    this.eventInteractionService.getObservable().subscribe((event: EventData) => {
      switch (event.event) {
        case 'bollettaComplete':
          this.checkPromoBenchmarkVisibility();
          this.showContent$.set(true);
          break;
        default:
          break;
      }
    });
  }

  onVisibilityChanged(element: string, visible: boolean) {
    if(Object.keys(this.visibilityState).includes(element) && visible) {
      this.visibilityState[element] = '*' ;
    }
  }

  // @HostListener('window:scroll', ['$event'])
  // onScroll(event: any) {
   
  //   if (this.seen) {
  //     return;
  //   }

  //   const bottomOfWindow = event.target.scrollingElement.scrollTop + window.innerHeight > (event.target.scrollingElement.scrollHeight*0.5);
  //   console.log(bottomOfWindow);
  //   if (bottomOfWindow && !this.seen) {
  //     this.seen = confirm('message');
  //   }
  // }

  
  goToSelfcaring() {
    this.router.navigate([environment.routingBasePath + '/selfcaring'], { fragment: 'BENCHMARK' });
  }

 checkPromoBenchmarkVisibility() {
    this.landingService.getDashboard().then((res) => {
      let company = res?.company;
      if(company?.delfi_report_max_requests && Number(company?.delfi_report_max_requests) > 0 &&  Number(company?.delfi_report_max_requests) < 11 ) {
        this.showBenhmarkPromo$.set(true);
    }
    }).catch((err: any) => {
      console.log('err', err);
      this.showBenhmarkPromo$.set(false);
    })

  }

}
